"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _axios = _interopRequireDefault(require("axios"));

var _lodash = _interopRequireDefault(require("lodash"));

var _basic = _interopRequireDefault(require("./_basic"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var PGSqlApi =
/*#__PURE__*/
function (_BasicApi) {
  (0, _inherits2.default)(PGSqlApi, _BasicApi);

  /**
   * Represents a Tables Api.
   * @constructor
   * @param {Function} param0.userTokenFactory Function that returns access token
   * @param {String} param0.PGSqlUrl Url of api
   * @param {Function} param0.accountIdFactory Function that returns accountId for cross account requests
   * @param {Number} param0.timeout Request timeout in ms
   * @param {Function} param0.log Log function to log queries. for exmaple console.log
   */
  function PGSqlApi(_ref) {
    var _this;

    var userTokenFactory = _ref.userTokenFactory,
        PGSqlUrl = _ref.PGSqlUrl,
        accountIdFactory = _ref.accountIdFactory,
        timeout = _ref.timeout,
        log = _ref.log;
    (0, _classCallCheck2.default)(this, PGSqlApi);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PGSqlApi).call(this, {
      userTokenFactory: userTokenFactory,
      accountIdFactory: accountIdFactory
    }));
    _this.PGSqlUrl = PGSqlUrl;
    _this.axios = _axios.default.create(_objectSpread({}, timeout && {
      timeout: timeout
    }));
    _this.log = log;
    return _this;
  }

  (0, _createClass2.default)(PGSqlApi, [{
    key: "_callApi",
    value: function () {
      var _callApi2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(_ref2) {
        var url, data, method, _ref3, res;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = _ref2.url, data = _ref2.data, method = _ref2.method;
                if (this.log) this.log(data);
                _context.next = 4;
                return this.axios({
                  url: "".concat(this.PGSqlUrl, "/").concat(this.accountIdFactory, "/").concat(url),
                  method: method,
                  data: data,
                  headers: {
                    Authorization: this.userToken,
                    'Content-Type': 'application/json;charset=UTF-8'
                  }
                }).catch(function (e) {
                  var response = _lodash.default.get(e, 'response.data', e);

                  var err = new Error(response.message);
                  err.data = response;
                  throw err;
                });

              case 4:
                _ref3 = _context.sent;
                res = _ref3.data;
                return _context.abrupt("return", res);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _callApi(_x) {
        return _callApi2.apply(this, arguments);
      }

      return _callApi;
    }()
    /**
     * @param {String} param0.query cypher query for graph db
     * @param {Object} param0.params Object with params to query 
     * @param {String} param0.database Database name
     */

  }, {
    key: "executeQuery",
    value: function () {
      var _executeQuery = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(_ref4) {
        var query, params, database;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                query = _ref4.query, params = _ref4.params, database = _ref4.database;
                return _context2.abrupt("return", this._callApi({
                  data: {
                    query: query,
                    params: params,
                    database: database
                  },
                  method: 'post',
                  url: 'query'
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function executeQuery(_x2) {
        return _executeQuery.apply(this, arguments);
      }

      return executeQuery;
    }()
    /**
     * 
     * @returns {Array} database names
     */

  }, {
    key: "listDatabases",
    value: function () {
      var _listDatabases = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3() {
        var _ref5, databases;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._callApi({
                  method: 'get',
                  url: 'databases'
                });

              case 2:
                _ref5 = _context3.sent;
                databases = _ref5.databases;
                return _context3.abrupt("return", databases);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function listDatabases() {
        return _listDatabases.apply(this, arguments);
      }

      return listDatabases;
    }()
    /**
     * 
     * @param {String} param0.database database name
     */

  }, {
    key: "createDatabase",
    value: function () {
      var _createDatabase = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(_ref6) {
        var database;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                database = _ref6.database;
                return _context4.abrupt("return", this._callApi({
                  data: {
                    database: database
                  },
                  method: 'put',
                  url: 'databases'
                }));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function createDatabase(_x3) {
        return _createDatabase.apply(this, arguments);
      }

      return createDatabase;
    }()
    /**
     * 
     * @param {String} param0.database database name
     */

  }, {
    key: "getDatabaseInfo",
    value: function () {
      var _getDatabaseInfo = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(_ref7) {
        var database;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                database = _ref7.database;
                return _context5.abrupt("return", this._callApi({
                  method: 'get',
                  url: "databases/".concat(encodeURIComponent(database))
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getDatabaseInfo(_x4) {
        return _getDatabaseInfo.apply(this, arguments);
      }

      return getDatabaseInfo;
    }()
    /**
     * 
     * @param {String} param0.database database name
     */

  }, {
    key: "dropDatabase",
    value: function () {
      var _dropDatabase = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(_ref8) {
        var database;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                database = _ref8.database;
                return _context6.abrupt("return", this._callApi({
                  data: {
                    database: database
                  },
                  method: 'delete',
                  url: 'databases'
                }));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function dropDatabase(_x5) {
        return _dropDatabase.apply(this, arguments);
      }

      return dropDatabase;
    }()
    /**
     * 
     * @param {String} param0.database database name
     * @param {String} param0.schema schema name. default public
     * @returns ['table_name']
     */

  }, {
    key: "listTables",
    value: function () {
      var _listTables = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(_ref9) {
        var database, _ref9$schema, schema, _ref10, rows;

        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                database = _ref9.database, _ref9$schema = _ref9.schema, schema = _ref9$schema === void 0 ? 'public' : _ref9$schema;
                _context7.next = 3;
                return this.executeQuery({
                  query: "SELECT table_name FROM information_schema.tables \n      WHERE table_schema = '".concat(schema, "'\n      and table_type = 'BASE TABLE';"),
                  database: database
                });

              case 3:
                _ref10 = _context7.sent;
                rows = _ref10.rows;
                return _context7.abrupt("return", rows.map(function (x) {
                  return x.table_name;
                }));

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function listTables(_x6) {
        return _listTables.apply(this, arguments);
      }

      return listTables;
    }()
    /**
     * 
     * @param {String} param0.database database name
     * @returns ['schema_name']
     */

  }, {
    key: "listSchemas",
    value: function () {
      var _listSchemas = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(_ref11) {
        var database, _ref12, rows;

        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                database = _ref11.database;
                _context8.next = 3;
                return this.executeQuery({
                  query: "SELECT schema_name FROM information_schema.schemata \n        where schema_name not in ('pg_catalog', 'information_schema')",
                  database: database
                });

              case 3:
                _ref12 = _context8.sent;
                rows = _ref12.rows;
                return _context8.abrupt("return", rows.map(function (x) {
                  return x.schema_name;
                }));

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function listSchemas(_x7) {
        return _listSchemas.apply(this, arguments);
      }

      return listSchemas;
    }()
    /**
     * 
     * @param {String} param0.schema schema name
     * @param {String} param0.database database name
     */

  }, {
    key: "createSchema",
    value: function () {
      var _createSchema = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(_ref13) {
        var database, schema;
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                database = _ref13.database, schema = _ref13.schema;
                return _context9.abrupt("return", this.executeQuery({
                  query: "create schema ".concat(schema, ";"),
                  database: database
                }));

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function createSchema(_x8) {
        return _createSchema.apply(this, arguments);
      }

      return createSchema;
    }()
    /**
     * 
     * @param {String} param0.schema schema name
     * @param {String} param0.database database name
     */

  }, {
    key: "dropSchema",
    value: function () {
      var _dropSchema = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10(_ref14) {
        var database, schema;
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                database = _ref14.database, schema = _ref14.schema;
                return _context10.abrupt("return", this.executeQuery({
                  query: "drop schema ".concat(schema, " cascade;"),
                  database: database
                }));

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function dropSchema(_x9) {
        return _dropSchema.apply(this, arguments);
      }

      return dropSchema;
    }()
    /**
     * 
     * @param {String} param0.schema schema name
     * @param {String} param0.database database name
     * @param {String} param0.table table name
     */

  }, {
    key: "dropTable",
    value: function () {
      var _dropTable = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11(_ref15) {
        var database, schema, table;
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                database = _ref15.database, schema = _ref15.schema, table = _ref15.table;
                return _context11.abrupt("return", this.executeQuery({
                  query: "drop table ".concat(schema, ".").concat(table, ";"),
                  database: database
                }));

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function dropTable(_x10) {
        return _dropTable.apply(this, arguments);
      }

      return dropTable;
    }()
    /**
     * 
     * @param {String} param0.schema schema name
     * @param {String} param0.database database name
     * @param {String} param0.table table name
     * @param {Array} param0.columns [{name:"col",type:"integer"}]
     * @param {String} param0.primaryKey comma separated list of columns for primary key
     * 
     */

  }, {
    key: "createTable",
    value: function () {
      var _createTable = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee12(_ref16) {
        var database, schema, table, columns, primaryKey;
        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                database = _ref16.database, schema = _ref16.schema, table = _ref16.table, columns = _ref16.columns, primaryKey = _ref16.primaryKey;
                return _context12.abrupt("return", this.executeQuery({
                  query: "create  table ".concat(schema, ".").concat(table, " (").concat(columns.map(function (x) {
                    return "".concat(x.name, " ").concat(x.type);
                  }).join(', '), ", primary key (").concat(primaryKey, "));"),
                  database: database
                }));

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function createTable(_x11) {
        return _createTable.apply(this, arguments);
      }

      return createTable;
    }()
    /**
     * 
     * @param {String} param0.schema schema name
     * @param {String} param0.database database name
     * @param {String} param0.table table name
     * @param {Array} param0.columns [{name:"col",type:"integer"}]
     */

  }, {
    key: "addColumns",
    value: function () {
      var _addColumns = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee13(_ref17) {
        var database, schema, table, columns;
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                database = _ref17.database, schema = _ref17.schema, table = _ref17.table, columns = _ref17.columns;
                return _context13.abrupt("return", this.executeQuery({
                  query: "alter  table ".concat(schema, ".").concat(table, " ").concat(columns.map(function (x) {
                    return "add column ".concat(x.name, " ").concat(x.type);
                  }).join(', '), ";"),
                  database: database
                }));

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function addColumns(_x12) {
        return _addColumns.apply(this, arguments);
      }

      return addColumns;
    }()
    /**
     * 
     * @param {String} param0.schema schema name
     * @param {String} param0.database database name
     * @param {String} param0.table table name
     * @param {Array} param0.rows [{}]
     * @param {Integer} param0.chunkSize divide array into chunks to make small payload
     * @param {Object} param0.context {progress} to watch progress of insert will be set from 0 to 100
     */

  }, {
    key: "insert",
    value: function () {
      var _insert = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee14(_ref18) {
        var _this2 = this;

        var database, schema, table, rows, _ref18$chunkSize, chunkSize, context, res, allKeys, keys, stringifyRow, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step$value, index, chunk, query;

        return _regenerator.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                database = _ref18.database, schema = _ref18.schema, table = _ref18.table, rows = _ref18.rows, _ref18$chunkSize = _ref18.chunkSize, chunkSize = _ref18$chunkSize === void 0 ? 300 : _ref18$chunkSize, context = _ref18.context;
                res = [];
                if (!_lodash.default.isArray(rows)) rows = [rows];
                allKeys = {};
                rows.forEach(function (x) {
                  return Object.assign(allKeys, x);
                });
                keys = Object.keys(allKeys);

                stringifyRow = function stringifyRow(row) {
                  return "".concat(keys.map(function (key) {
                    return _this2.encodeValue(row[key]);
                  }).join(', '));
                }; // eslint-disable-next-line no-unused-vars


                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context14.prev = 10;
                _iterator = _lodash.default.chunk(rows, chunkSize).entries()[Symbol.iterator]();

              case 12:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context14.next = 24;
                  break;
                }

                _step$value = (0, _slicedToArray2.default)(_step.value, 2), index = _step$value[0], chunk = _step$value[1];
                query = "insert into  ".concat(schema, ".").concat(table, " (").concat(keys.join(', '), ")\nvalues (").concat(chunk.map(stringifyRow).join('), ('), ");");
                _context14.t0 = res;
                _context14.next = 18;
                return this.executeQuery({
                  query: query,
                  database: database
                });

              case 18:
                _context14.t1 = _context14.sent;

                _context14.t0.push.call(_context14.t0, _context14.t1);

                if (context) context.progress = (index + 1) / (rows.length / chunkSize) * 100;

              case 21:
                _iteratorNormalCompletion = true;
                _context14.next = 12;
                break;

              case 24:
                _context14.next = 30;
                break;

              case 26:
                _context14.prev = 26;
                _context14.t2 = _context14["catch"](10);
                _didIteratorError = true;
                _iteratorError = _context14.t2;

              case 30:
                _context14.prev = 30;
                _context14.prev = 31;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 33:
                _context14.prev = 33;

                if (!_didIteratorError) {
                  _context14.next = 36;
                  break;
                }

                throw _iteratorError;

              case 36:
                return _context14.finish(33);

              case 37:
                return _context14.finish(30);

              case 38:
                return _context14.abrupt("return", res);

              case 39:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[10, 26, 30, 38], [31,, 33, 37]]);
      }));

      function insert(_x13) {
        return _insert.apply(this, arguments);
      }

      return insert;
    }()
    /**
     * 
     * @param {*} value any value to encode and paste to pg query
     */
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: "encodeValue",
    value: function encodeValue(value) {
      if (_lodash.default.isUndefined(value) || value === '' || _lodash.default.isNull(value)) return 'NULL';
      if (_lodash.default.isString(value)) return "'".concat(value.replaceAll("'", "''"), "'");
      if (_lodash.default.isNumber(value) || _lodash.default.isBoolean(value)) return value;
      return "'".concat(JSON.stringify(value).replaceAll("'", "''"), "'");
    }
    /**
     * 
     * @param {String} param0.database database name
     * @param {String} param0.query example: select * from table. query must be select only, without limit and offset
     * @param {Integer} param0.chunkSize size of chunk to export data
     * @param {Object} param0.context {progress, total} to watch progress of select will be set from 0 to 100
     * @param {Number} param0.offset offset to start with
     * @param {Number} param0.limit total limit of records to return
     * @returns {Array} array of query results
     */

  }, {
    key: "selectAll",
    value: function () {
      var _selectAll = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee15(_ref19) {
        var database, query, context, _ref19$chunkSize, chunkSize, _ref19$offset, offset, limit, count, rows, result, _ref20, _rows;

        return _regenerator.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                database = _ref19.database, query = _ref19.query, context = _ref19.context, _ref19$chunkSize = _ref19.chunkSize, chunkSize = _ref19$chunkSize === void 0 ? 1000 : _ref19$chunkSize, _ref19$offset = _ref19.offset, offset = _ref19$offset === void 0 ? 0 : _ref19$offset, limit = _ref19.limit;
                result = [];

                if (limit && limit < chunkSize) {
                  chunkSize = limit;
                }

                if (!context) {
                  _context15.next = 10;
                  break;
                }

                _context15.next = 6;
                return this.executeQuery({
                  query: "select count(*) from (".concat(query, ") x"),
                  database: database
                });

              case 6:
                _ref20 = _context15.sent;
                _rows = _ref20.rows;
                count = _rows[0].count; // eslint-disable-next-line require-atomic-updates

                context.total = count;

              case 10:
                _context15.next = 12;
                return this.executeQuery({
                  query: "".concat(query, " offset ").concat(offset, " limit ").concat(chunkSize),
                  database: database
                });

              case 12:
                rows = _context15.sent.rows;
                offset += chunkSize;
                result = result.concat(rows);

                if (context) {
                  // eslint-disable-next-line require-atomic-updates
                  context.progress = Math.min(offset / count * 100, 100);
                }

                if (!(result.length >= limit)) {
                  _context15.next = 19;
                  break;
                }

                result = result.slice(0, limit);
                return _context15.abrupt("break", 20);

              case 19:
                if (rows.length) {
                  _context15.next = 10;
                  break;
                }

              case 20:
                return _context15.abrupt("return", result);

              case 21:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function selectAll(_x14) {
        return _selectAll.apply(this, arguments);
      }

      return selectAll;
    }()
    /**
     * 
     * @param {String} param0.schema schema name
     * @param {String} param0.database database name
     * @param {String} param0.table table name
     * @returns {String} id,id2 comma separeted list of primary keys
     */

  }, {
    key: "getPrimaryKeys",
    value: function () {
      var _getPrimaryKeys = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee16(_ref21) {
        var database, schema, table, _ref22, rows;

        return _regenerator.default.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                database = _ref21.database, schema = _ref21.schema, table = _ref21.table;
                _context16.next = 3;
                return this.executeQuery({
                  database: database,
                  query: "SELECT string_agg(a.attname, ', ') AS pk\nFROM\n    pg_constraint AS c\n    CROSS JOIN LATERAL UNNEST(c.conkey) AS cols(colnum) -- conkey is a list of the columns of the constraint; so we split it into rows so that we can join all column numbers onto their names in pg_attribute\n    INNER JOIN pg_attribute AS a ON a.attrelid = c.conrelid AND cols.colnum = a.attnum\nWHERE\n    c.contype = 'p' -- p = primary key constraint\n    AND c.conrelid = '".concat(schema, ".").concat(table, "'::REGCLASS;")
                });

              case 3:
                _ref22 = _context16.sent;
                rows = _ref22.rows;
                return _context16.abrupt("return", rows[0].pk);

              case 6:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function getPrimaryKeys(_x15) {
        return _getPrimaryKeys.apply(this, arguments);
      }

      return getPrimaryKeys;
    }()
    /**
     * 
     * @param {String} param0.schema schema name
     * @param {String} param0.database database name
     * @param {String} param0.table table name
     * @param {String} param0.key key to update
     * @param {*} param0.value value to set
     * @param {Object} param0.row row object {id, col1,col2...} need to get primary key value
     * @param {String} param0.primaryKeys comma separated list of primary keys
     */

  }, {
    key: "editRow",
    value: function () {
      var _editRow = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee17(_ref23) {
        var _this3 = this;

        var database, schema, table, key, value, row, primaryKeys, pk;
        return _regenerator.default.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                database = _ref23.database, schema = _ref23.schema, table = _ref23.table, key = _ref23.key, value = _ref23.value, row = _ref23.row, primaryKeys = _ref23.primaryKeys;
                value = this.encodeValue(value);
                pk = primaryKeys.split(',').map(function (x) {
                  return _lodash.default.trim(x);
                });
                return _context17.abrupt("return", this.executeQuery({
                  database: database,
                  query: "update ".concat(schema, ".").concat(table, " \nset ").concat(key, " = ").concat(value, "\nwhere ").concat(pk.map(function (primaryKey) {
                    return "".concat(primaryKey, " = ").concat(_this3.encodeValue(row[primaryKey]));
                  }).join(' AND '))
                }));

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function editRow(_x16) {
        return _editRow.apply(this, arguments);
      }

      return editRow;
    }()
    /**
     * @param {String} param0.schema schema name
     * @param {String} param0.database database name
     * @param {String} param0.table table name
     * @param {String} param0.primaryKeys comma separated list of primary keys
     * @param {Array} param0.rows array of rows to delete
    */

  }, {
    key: "deleteRows",
    value: function () {
      var _deleteRows = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee18(_ref24) {
        var _this4 = this;

        var database, schema, table, rows, primaryKeys, pk;
        return _regenerator.default.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                database = _ref24.database, schema = _ref24.schema, table = _ref24.table, rows = _ref24.rows, primaryKeys = _ref24.primaryKeys;
                pk = primaryKeys.split(',').map(function (x) {
                  return _lodash.default.trim(x);
                });
                return _context18.abrupt("return", this.executeQuery({
                  database: database,
                  query: "delete from ".concat(schema, ".").concat(table, " \nwhere (").concat(rows.map(function (row) {
                    return "".concat(pk.map(function (primaryKey) {
                      return "".concat(primaryKey, " = ").concat(_this4.encodeValue(row[primaryKey]));
                    }).join(' AND '));
                  }).join(') \nOR ('), ")")
                }));

              case 3:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function deleteRows(_x17) {
        return _deleteRows.apply(this, arguments);
      }

      return deleteRows;
    }()
    /**
     * @description generate create table query for existing table
     * @param {String} param0.schema schema name
     * @param {String} param0.database database name
     * @param {String} param0.table table name
     * @returns {String} code to create table
    */

  }, {
    key: "generateTableSchema",
    value: function () {
      var _generateTableSchema = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee19(_ref25) {
        var database, schema, table, _ref26, rows;

        return _regenerator.default.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                database = _ref25.database, schema = _ref25.schema, table = _ref25.table;
                _context19.next = 3;
                return this.executeQuery({
                  database: database,
                  query: "SELECT 'CREATE TABLE ' || '".concat(schema, ".").concat(table, "' || ' (' || '\n' || '' || \n        string_agg(column_list.column_expr, ', ' || '\n' || '') || \n        '' || ',\n' || 'PRIMARY KEY (' || (SELECT string_agg(a.attname, ', ') AS pk\n    FROM\n        pg_constraint AS c\n        CROSS JOIN LATERAL UNNEST(c.conkey) AS cols(colnum) -- conkey is a list of the columns of the constraint; so we split it into rows so that we can join all column numbers onto their names in pg_attribute\n        INNER JOIN pg_attribute AS a ON a.attrelid = c.conrelid AND cols.colnum = a.attnum\n    WHERE\n        c.contype = 'p' -- p = primary key constraint\n        AND c.conrelid = '").concat(schema, ".").concat(table, "'::REGCLASS limit 1) || '));'  code\n    FROM (\n      SELECT '    ' || column_name || ' ' || data_type || \n           coalesce('(' || character_maximum_length || ')', '') || \n           case when is_nullable = 'YES' then '' else ' NOT NULL' end as column_expr\n      FROM information_schema.columns\n      WHERE table_schema = '").concat(schema, "' AND table_name = '").concat(table, "'\n      ORDER BY ordinal_position)  column_list;")
                });

              case 3:
                _ref26 = _context19.sent;
                rows = _ref26.rows;
                return _context19.abrupt("return", rows[0].code);

              case 6:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function generateTableSchema(_x18) {
        return _generateTableSchema.apply(this, arguments);
      }

      return generateTableSchema;
    }()
    /**
     * 
     * @returns {Object} used size and limit in MB {"usedSize":179,"sizeLimit":200}
     */

  }, {
    key: "getDBSize",
    value: function () {
      var _getDBSize = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee20() {
        return _regenerator.default.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                return _context20.abrupt("return", this._callApi({
                  url: 'size'
                }));

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function getDBSize() {
        return _getDBSize.apply(this, arguments);
      }

      return getDBSize;
    }()
  }]);
  return PGSqlApi;
}(_basic.default);

var _default = PGSqlApi;
exports.default = _default;